import * as Styled from './SubTitleImage.styled';
import type { SubTitleImageProps } from './SubTitleImage.typed';

const SubTitleImage = (props: SubTitleImageProps) => {
  const { subTitle, imageUrl, imageAltText, className } = props;
  return (
    <Styled.Container className={className}>
      <Styled.Subtitle>{subTitle}</Styled.Subtitle>
      <Styled.Image src={imageUrl} alt={imageAltText} />
    </Styled.Container>
  );
};

export { SubTitleImage };
